import { render, staticRenderFns } from "./BcbCampaignSendNotification.vue?vue&type=template&id=7b4ccfaf&scoped=true"
import script from "./BcbCampaignSendNotification.vue?vue&type=script&lang=js"
export * from "./BcbCampaignSendNotification.vue?vue&type=script&lang=js"
import style0 from "./BcbCampaignSendNotification.vue?vue&type=style&index=0&id=7b4ccfaf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4ccfaf",
  null
  
)

export default component.exports